import { Ability } from "@casl/ability"
const ability = new Ability()
export default ability
